// Shared bonus-status palette + helpers. The same status colour must be used
// in the stacked bar, the timeline strip and any detail panels.

export const STATUS_COLOR = {
  won: '#00c896',     // wager_done — bonus wagered through successfully
  lost: '#a85d5d',    // lost — a normal outcome, not alarming (muted red)
  active: '#4fc3f7',  // handle_bets — currently being wagered
  pending: '#e8d36b', // issued — not yet activated
  expired: '#b07d3a',  // expired — issued but never activated, past valid_until (amber)
  canceled: '#7c5fa8', // canceled — voided before activation (muted purple)
};

export const STATUS_LABEL = {
  won: 'Finished · completed',
  lost: 'Finished · lost',
  active: 'Active',
  pending: 'Pending',
  expired: 'Expired (unused)',
  canceled: 'Canceled',
};

// Stack / render order, bottom→top.
export const SEGMENTS = ['won', 'lost', 'active', 'pending', 'expired', 'canceled'];

// activationColor — activation-rate thresholds (30 / 60) are placeholder
// guesses; recalibrate against the real distribution across all VIPs.
export function activationColor(rate) {
  if (rate == null) return '#7a8499';
  if (rate < 0.3) return '#e05555';
  if (rate <= 0.6) return '#e0a23c';
  return '#00c896';
}

// segmentOf maps an individual BonusRow to one of the six status segments
// using the action field alone (no status field on individual rows).
export function segmentOf(row) {
  const action = String(row.action || '').toLowerCase();
  if (action === 'wager_done') return 'won';
  if (action === 'lost') return 'lost';
  if (action === 'handle_bets') return 'active';
  if (action === 'issued') return 'pending';
  if (action === 'expired') return 'expired';
  if (action === 'canceled') return 'canceled';
  return 'expired'; // unknown — render neutral
}
